<template>
  <div class="page-header">
    <div class="back-btn cursor-pointer" @click="$router.go(-1)">
      <svg
        class="mt-1"
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.29767 8.36137L8.71815 13.7818L7.5 15L0 7.5L7.5 0L8.71815 1.21815L3.29767 6.63863H15.8614V8.36137H3.29767Z"
          fill="#F57A4D"
        />
      </svg>
      <span class="text-secondary-orange font-semibold pl-2">Back</span>
    </div>
    <div class="pt-2">
      <h1 class="sub-heading">{{ title }}</h1>
      <div class="roles-privileges__breadcrumb">
        <small class="text-grey">{{ breadcrumbText }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
    },
    breadcrumbText: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
.back-btn {
  display: flex;
  align-items: flex-start;
}
/* .page-header {
  display: flex;
} */
</style>
